import * as Yup from "yup";


export const ClientEngagementValidation = Yup.object({
    opportunityId: Yup.string()
        .nullable()
        .max(8, "Opportunity ID must be at most 8 characters"),

    clientId: Yup.string()
        .required("Client is required")
        .length(36, "Must be a valid client"),

    feedback: Yup.string()
        .nullable()
        .max(2000, "Feedback must be at most 2000 characters"),

    dateOfNextCheckin: Yup.date()
        .nullable()
        .typeError("Must be a valid date")
        .test('min-date', 'Date cannot be more than 1 month in the past', (value) => {
            if (!value) return true;
            const min = new Date();
            min.setMonth(min.getMonth() - 1);
            return value >= min;
        })
        .test('max-date', 'Date cannot be more than 1 year in the future', (value) => {
            if (!value) return true;
            const max = new Date();
            max.setFullYear(max.getFullYear() + 1);
            return value <= max;
        }),
});